// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2gZpX","dragIcon":"Choice_dragIcon__2xb0S","left":"Choice_left__1KHi2","input":"Choice_input__2ECMd"};